<script setup lang="ts">
import Card from '@/components/Card.vue';
import { useAuthStore } from '@/stores/auth';

const authStore = useAuthStore();
</script>

<template>
    <v-fade-transition appear>
        <v-row class="d-flex justify-md-start justify-center">
            <Card
                name="Medewerkers"
                imageUrl="/images/employees.svg"
                :route="{ name: 'employees', params: { organizationId: authStore.getCurrentOrganization()._id } }"
                text="Hier kan je alle medewerkers van dit bedrijf inzien en wijzigen."
            />

            <Card
                v-if="!authStore.isReadOnly()"
                name="Notificaties"
                imageUrl="/images/notifications.svg"
                :route="{ name: 'admin-notifications-create' }"
                text="Hier kunnen notificaties gemaakt en verstuurd worden"
            />

            <Card
                name="Vestigingen"
                imageUrl="/images/company.svg"
                :route="{ name: 'organization-underlying', params: { organizationId: authStore.getCurrentOrganization()._id } }"
                text="Hier kan je (sub)vestigingen aanmaken en configureren."
            />

            <Card name="Teams" imageUrl="/images/teams.svg" route="/beheer/teams" text="Hier kun je teams aanmaken en configureren." />

            <Card
                name="Bronnen"
                imageUrl="/images/sources.svg"
                :route="{ name: 'organization-sources', params: { organizationId: authStore.getCurrentOrganization()._id } }"
                text="Hier kan je bronnen aanmaken en configureren."
            />
        </v-row>
    </v-fade-transition>
</template>
